
import SessionHandler from '../utils/sessionHandler';
const BASE_URL = 'https://crd-training.in/api/v1';
const checkSessionExpiration = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    if (errorData.error === "Session expired, please login again" || response.status === 401) {
      SessionHandler.handleSessionExpiration();
      throw new Error('Session expired');
    }
    throw new Error(errorData.message || 'API request failed');
  }
  return response.json();
};
// API service for authentication
const authService = {
  // Login function that calls the API
  login: async (username, password) => {
    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Login failed');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },
};

// API service for master data
const masterService = {
  // Get institutes
  // Add this method to the masterService object, right after getInfraSchemes:

// Get admin schemes
getAdminSchemes: async () => {
  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${BASE_URL}/master/scheme/admin`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken
      }
    });
    
    if (!response.ok) {
      // Handle non-2xx responses
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch admin schemes');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching admin schemes:', error);
    throw error;
  }
},
  getInstitutes: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/institute`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch institutes');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching institutes:', error);
      throw error;
    }
  },
  
// Move the getTrainingTitles method from infrastructureService to masterService

// In the masterService object, add this method after getInfraTitles:
// Get training titles for a scheme
getTrainingTitles: async (schemeId) => {
  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${BASE_URL}/master/title/training/${schemeId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken
      }
    });
    
    if (!response.ok) {
      // Handle non-2xx responses
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch training titles');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching training titles:', error);
    return { error: true, message: error.message };
  }
},
  getClientile: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/clientele`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch clientile categories');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching clientile categories:', error);
      throw error;
    }
  },
  
  // Get training schemes
  getSchemes: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/scheme/training`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch schemes');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching schemes:', error);
      throw error;
    }
  },
  
  // Get infrastructure schemes - NEW
  getInfraSchemes: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/scheme/infra`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch infrastructure schemes');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching infrastructure schemes:', error);
      throw error;
    }
  },
  
  // Get infra titles for a scheme - NEW
  getInfraTitles: async (schemeId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/title/infra/${schemeId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch work titles');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching work titles:', error);
      throw error;
    }
  },
  
  // Get trainings
  getTrainings: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/training`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch trainings');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching trainings:', error);
      throw error;
    }
  },
  
  // Get states
  getStates: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/state`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch states');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching states:', error);
      throw error;
    }
  },
  
  // Get regions
  getRegions: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/regional`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch regions');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching regions:', error);
      throw error;
    }
  },
  
  // Get districts
  getDistricts: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/master/district`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch districts');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching districts:', error);
      throw error;
    }
  }
};

// API service for training data
const trainingService = {
  // Add training
  addTraining: async (trainingData) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/training`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify(trainingData)
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add training');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error adding training:', error);
      throw error;
    }
  },
  
  // Get project details
  getProjectDetails: async (projectId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/detail/${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch project details');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching project details:', error);
      throw error;
    }
  },
  
  // Get training list
  getTrainingList: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/training/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch training list');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching training list:', error);
      throw error;
    }
  },
  
  // Approve training
  approveTraining: async (trainingId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/training/${trainingId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify({ status: 'Approved' })
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to approve training');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error approving training:', error);
      return { error: true, message: error.message };
    }
  }
};

// API service for infrastructure data - NEW
const infrastructureService = {
  // Add infrastructure project
  addInfrastructure: async (infrastructureData) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/infrastructure`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify(infrastructureData)
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add infrastructure project');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error adding infrastructure project:', error);
      throw error;
    }
  },
  
  // Get infrastructure projects list
  getInfrastructureList: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/infrastructure/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch infrastructure list');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching infrastructure list:', error);
      throw error;
    }
  },
  
  // Get infrastructure project details
  getInfrastructureDetails: async (projectId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/infrastructure/detail/${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch infrastructure details');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching infrastructure details:', error);
      throw error;
    }
  },
  // Add this method to your masterService object in api.js

// Get training titles for a scheme
// Move the getTrainingTitles method from infrastructureService to masterService

// In the masterService object, add this method after getInfraTitles:
// Get training titles for a scheme

  // Approve infrastructure project
  approveInfrastructure: async (projectId) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/infrastructure/${projectId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify({ status: 'Approved' })
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to approve infrastructure project');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error approving infrastructure project:', error);
      return { error: true, message: error.message };
    }
  }
};

// API service for ledger
const ledgerService = {
  // Get ledger transactions
  getTransactions: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/ledger/transaction/cbe`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch transactions');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching transactions:', error);
      throw error;
    }
  },
  
  // Get balance for all departments
  getBalance: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/ledger/balance`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch balance data');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching balance data:', error);
      throw error;
    }
  },
  
  // Get transactions for a specific department
  getDepartmentTransactions: async (deptCode) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/ledger/transaction/${deptCode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // Handle non-2xx responses
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch transaction data');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching transaction data:', error);
      throw error;
    }
  }
};

const notificationService = {
  // Get all notifications
  getNotifications: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/notification`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      return await checkSessionExpiration(response);
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }
};

// API service for reports
const reportService = {
  // Get all report data
  getReports: async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}/project/report`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch reports');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching reports:', error);
      throw error;
    }
  },
  
  // Get selected report data by IDs
  getSelectedReports: async (ids) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const idsParam = ids.join(',');
      const response = await fetch(`${BASE_URL}/project/report/selected?ids=${idsParam}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch selected reports');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching selected reports:', error);
      throw error;
    }
  }
};

// Export all services
export default {
  auth: authService,
  master: masterService,  // Already includes the infrastructure methods
  training: trainingService,
  infrastructure: infrastructureService,  // New infrastructure service
  notification: notificationService,
  ledger: ledgerService, 
   report: reportService,
  BASE_URL,
};